import { SvgIcon, Text } from '@cinch-labs/design-system'
import styles from './sold-by-partner-info.module.css'
import { DynamicDrawer } from '../dynamic-drawer/dynamic-drawer'
import cx from 'classnames'

export type SoldByPartnerInfoProps = {
  callToActionText?: string
  callToActionClassName?: string
  onCallToActionClick?: () => void
}

/**
 * SoldByPartnerInfo is a component that displays a button with an icon and text, and a drawer with information about the sold by partner.
 * @returns A component that displays a button with an icon and text, and a drawer with information about the sold by partner.
 */
export const SoldByPartnerInfo = ({
  callToActionText = 'Sold by our partner Marshall Motor Group',
  callToActionClassName = '',
  onCallToActionClick,
}: SoldByPartnerInfoProps) => (
  <DynamicDrawer
    ariaLabel="Information drawer about sales by our partner Marshall Motor Group"
    title="Sold by our partner Marshall Motor Group"
    contentNode={
      <div className={styles.sizingWrapper}>
        <Text>We’ve partnered with Marshall to bring you new cars.</Text>
        <Text style={{ marginBottom: '16px', marginTop: '16px' }}>
          Marshall has over 115 years of motoring know-how and is one of the
          UK’s leading automotive retailers.
        </Text>
        <Text>
          Once you’ve found your new car through cinch, you’ll be asked to fill
          out a quick enquiry form and the Marshall team will be in touch to
          discuss next steps.
        </Text>
      </div>
    }
    callToActionNode={
      <div
        className={cx(styles.container, callToActionClassName)}
        onClick={onCallToActionClick}
      >
        <SvgIcon name="info" size={24} color="mineShaft" />
        <span className={styles.text}>{callToActionText}</span>
      </div>
    }
  />
)
